import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useMemo } from 'react'
import { Tooltip, Stack, Typography, Chip, useTheme } from '@mui/material'
import _ from 'lodash'


const RelevanceFacts = ({ data }) => {
    const theme = useTheme();

  
  const columns = useMemo(() => [
    {
      header: 'Fact',
      accessorKey: 'Fact', // Accessor key for the sentiment data
      
    },
    {
      header: 'Explanation',
      accessorKey: 'Explanation', // Accessor key for phrasesString data
    },

  ], []);

  // Memoize table data
  const tableData = useMemo(() =>{
    if(!data){
        return []
    }
     if(JSON.parse(data===''?null:data)){
        const parsedData=JSON.parse(data)??{}
        return parsedData?.RelevanceFacts??[]
     }
    }, [data]);

  // Set up MaterialReactTable configuration
  const table = useMaterialReactTable({
    columns:columns,
    data: tableData??[],
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: {
      sx: {
        maxHeight: 'unset',
        backgroundColor: theme.palette.background.paper,
        overflow: 'hidden'
      }
    },
    muiTablePaperProps: {
      className: "std_table review-requests",
      sx: { boxShadow: 'none', backgroundColor: theme.palette.background.paper }
    },
    muiTableBodyCellProps: {
      sx: { border: 'none', backgroundColor: theme.palette.background.paper }
    }
  });

  // Render MaterialReactTable
  return (
    <MaterialReactTable table={table} 
      sx={{
        '& thead tr':{
          boxShadow: 'none'
        }
      }}
    />
  );
}

export default RelevanceFacts;
